import { Col, Collapse, Row } from "antd";
import React, { useEffect, useRef, useState } from "react";
import PrimaryButton from "../../biblio/Buttons/PrimaryButton";
import NewSurvey from "./NewSurvey";
import ResultSurvey from "./ResultSurvey";
import { scroll } from "../utils/utils";
import { useSelector } from "react-redux";
import { RootState } from "../../apis/store";
interface Props {
  survey: any;
}
const SurveyCollapse = ({ survey }: Props) => {
  const [activeItem, setActiveItem] = useState<"request" | "result">("request");
  const [selectedIndex, setSelectedIndex] = useState<string | undefined>("0");
  const currentRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    scroll(currentRef);
  }, [activeItem, selectedIndex]);
  const { type } = useSelector((state: RootState) => state.survey);
  return (
    <div className="takaful--collapse-profile-container">
      <Collapse
        className={`takaful--collapse-beneficiary-services takaful--collapse-profile takaful--survey-collapse`}
        accordion
        activeKey={selectedIndex}
        defaultActiveKey={["0"]}
        ref={currentRef}
        onChange={(e) => {
          setSelectedIndex(e.length > 0 ? e[0] : undefined);
          setActiveItem("request");
        }}
      >
        {survey?.map((element: any, index: number) => (
          <Collapse.Panel
            key={index}
            showArrow={false}
            className={`takaful--header-evaluation-Panel ${
              type === "internal"
                ? "takaful--header-internal"
                : "takaful--header-external"
            }`}
            header={
              <div className="takaful--header-profile-container">
                <Row
                  justify={"space-between"}
                  className="takaful--content-profile-box1"
                  style={{ marginBottom: "0" }}
                >
                  <Col xxl={1} xl={1} lg={1} md={1} sm={2} xs={2}>
                    <p className="takaful--content-services-request-p takaful--survey-text-color">
                      {index < 10 ? `0${index + 1}` : index + 1}
                    </p>
                  </Col>
                  <Col
                    xxl={type === "internal" ? 6 : 4}
                    xl={type === "internal" ? 7 : 5}
                    lg={type === "internal" ? 8 : 7}
                    md={type === "internal" ? 9 : 8}
                    sm={22}
                    xs={22}
                    className="takaful--content-profile-col"
                  >
                    <p className="takaful--content-services-request-p takaful--survey-text-color">
                      {element?.name}
                    </p>
                  </Col>
                  <Col
                    xxl={type === "internal" ? 12 : 14}
                    xl={type === "internal" ? 9 : 11}
                    lg={7}
                    md={6}
                    sm={24}
                    xs={24}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <hr className="takaful--survey-divider" />
                  </Col>
                  <Col
                    xxl={2}
                    xl={3}
                    lg={4}
                    md={4}
                    sm={11}
                    xs={11}
                    className="takaful--col-content"
                  >
                    <PrimaryButton
                      className={`takaful--survey-btn ${
                        // eslint-disable-next-line eqeqeq
                        activeItem === "request" && index + "" == selectedIndex
                          ? "takaful--inactive"
                          : ""
                      }`}
                      title="تقييم جديد"
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedIndex(index + "");
                        setActiveItem("request");
                      }}
                    />
                  </Col>
                  <Col
                    xxl={2}
                    xl={3}
                    lg={4}
                    md={4}
                    sm={11}
                    xs={11}
                    className="takaful--col-content"
                  >
                    <PrimaryButton
                      title="النتيجة"
                      className={`takaful--survey-result-btn ${
                        // eslint-disable-next-line eqeqeq
                        activeItem === "result" && index + "" == selectedIndex
                          ? "takaful--inactive"
                          : ""
                      }`}
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedIndex(index + "");
                        setActiveItem("result");
                      }}
                    />
                  </Col>
                </Row>
              </div>
            }
          >
            {activeItem === "request" ? (
              <NewSurvey
                setActiveItem={setActiveItem}
                surveyId={element?.id}
                questions={element?.questions}
              />
            ) : (
              <ResultSurvey questions={element?.questions} />
            )}
          </Collapse.Panel>
        ))}
      </Collapse>
    </div>
  );
};

export default SurveyCollapse;
